<template>
  <div id="DetallesConsultaDireccion_div">
    <div id="TituloConsultaDireccion_div" class="w-100">
      <h1 style="margin-bottom: 0px;">Cédula de Expediente {{ numeroExpediente }}</h1>
      <!-- <h3 style="margin-top: 0px;">Detalles de cédula pública</h3> -->
    </div>
    <div id="encabezado-contenedor-contenido" class="form-inline mt-3">
      <div class="flex-grow-1"><button type="button" @click="regresarAVistaPrincipal" class="btn btn-primary"><i class="fas fa-long-arrow-alt-left" style="font-size:20px;"></i></button></div>
      <div class="flex-grow-1" style="padding-left: 11em;"><h4>Detalles de cédula</h4></div>
      <div class="flex-grow-1"></div>
    </div>
    <div id="contendor-detalles" class="col-12 contenedor-informacion">
      <div class="d-flex justify-content-between mt-2 mb-2">
        <div style="width: 29%;">
          <InformacionBasicaDeCedula v-if="this.campoRequeridoEsValido(cedulaBD)" class="contenedor-color-negro"
              :titulo="'Información de cedula'" 
              :mostrarObservacionesAbogado="true"
              :cedula="cedulaBD"
              :esConsultaPublica="true"
              :key="'CIBCVDCP' + contRenderDocumento"></InformacionBasicaDeCedula>
        </div>
        <div style="width: 69%;">
            <div v-if="this.campoRequeridoEsValido(cedulaBD)" id="cedula_div" class="contenedor-color-negro form-group">
              <h5><i class="fas fa-info-circle"></i>&nbsp;Documento y resultado</h5>
              <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
              <div class="row">
                <div v-if="this.campoRequeridoEsValido(cedulaBD.ArchivoRuta)" class="form-group info col-12">
                  <div class="contenedor-documento-cedula">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex justify-content-between align-items-center">
                          <i class="fas fa-file-alt mr-2" style="font-size: 23px;"></i>
                          <span style="color: #000000; font-weight: bold;">Documento de cedula</span>
                      </div>
                      <div id="contenedor-acciones-documento">
                          <button @click="evtVisualizarDocumento" type="button" class="btn-sm btn-primary"><i class="fas fa-eye"></i>&nbsp;&nbsp;Ver documento</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group info col-6 pr-1" id="Estatus_div">
                  <h6>Estatus</h6>
                  <input class="form-control" type="text" v-model="estatus" disabled />
                </div>
                <div class="form-group info col-6" id="Resultado_div">
                  <h6>Resultado</h6>
                  <input class="form-control" type="text" v-model="resultado" disabled />
                </div>
                <div class="form-group info col-12" id="ObservacionesResultado_div">
                  <h6>Observaciones de resultado</h6>
                  <textarea cols="3" class="form-control" v-model="observacionesResultado" disabled></textarea>
                </div>
              </div>
            </div>
          <div id="observaciones_div" class="contenedor-color-negro">
            <h5><i class="fas fa-sticky-note"></i>&nbsp;Observaciones</h5>
            <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
            <div class="row">
              <!-- SWITCH RANGO DE FECHAS -->
              <div id="switch-rango-dias" class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3">
                 <div style="display: flex; align-items: center;">
                  <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Rango de días:</strong> </h6>
                  <div class="btn-group btn-group-toggle switch-rango" data-toggle="buttons">
                      <label id="btn-switch-rangoDias-si" class="btn btn-secondary texto-ajustable-switch" @click="rangoDeDias = true">
                      <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>Si
                      </label>
                      <label id="btn-switch-rangoDias-no" class="btn btn-secondary active texto-ajustable-switch" @click="rangoDeDias = false">
                      <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">No
                      </label>
                  </div>
                </div>
              </div>
              <!-- OPCIONES RANGO DE FECHAS -->
              <div id="inputs-rango-fechas" v-if="rangoDeDias" class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 no-gutters">
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3">
                  <h6>Día de inicio</h6>
                  <CCatalogoGenerico class="p-0 m-0" 
                    v-on:valorParaElPadre="evtCambioDeDia($event,'INICIO')" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="catalogoDiasInicio.ID" 
                    :valorDefinido="catalogoDiasInicio.valor"
                    :textoOpcionesSingular="catalogoDiasInicio.TEXTO_SINGULAR"
                    :textoOpcionesPlural="catalogoDiasInicio.TEXTO_PLURAL"
                    :elementosCatalogo="DIAS_SEMANA"
                    :key="catalogoDiasInicio.key + catalogoDiasInicio.contRender"></CCatalogoGenerico>
                </div>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pt-0 pr-3">
                  <h6>Día de fin</h6>
                  <CCatalogoGenerico class="p-0 m-0" 
                    v-on:valorParaElPadre="evtCambioDeDia($event,'FIN')" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="catalogoDiasFin.ID" 
                    :valorDefinido="catalogoDiasFin.valor"
                    :textoOpcionesSingular="catalogoDiasFin.TEXTO_SINGULAR"
                    :textoOpcionesPlural="catalogoDiasFin.TEXTO_PLURAL"
                    :elementosCatalogo="DIAS_SEMANA"
                    :key="catalogoDiasFin.key + catalogoDiasFin.contRender"></CCatalogoGenerico>
                </div>
                <div class="form-group col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-3">
                  <h6>Hora de inicio</h6>
                  <input type="time" v-model="horaInicio" class="form-control" />
                </div>
                <div class="form-group col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-3">
                  <h6>Hora de fin</h6>
                  <input type="time" v-model="horaFin" class="form-control" />
                </div>
               <!--  <div v-if="this.campoRequeridoEsValido(catalogoDiasInicio.valor) && this.campoRequeridoEsValido(catalogoDiasFin.valor)" class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-0 pr-3 align-self-end">
                  <input class="form-control text-center" type="text" v-model="textoRangoDeFechas" disabled />
                </div> -->
              </div>
              <div id="inputs-check-dias" v-if="!rangoDeDias" class="form-group container-fluid pt-3">
                <h6>(*) Selecciona los dias y en que periodo de tiempo se puede realizar la notificación</h6>
                <div class="listado-seleccion row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 no-gutters">
                  <div :class="(todosLosDiasSeleccionados.seleccion) ? 'color-dia-seleccionado dia-seleccion row col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0 pt-1 pl-3 no-gutters' : 'dia-seleccion row col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0 pt-1 pl-3 no-gutters'">
                    <h6 @click="evtTodosLosDiasSeleccionados()"><i :class="(!todosLosDiasSeleccionados.seleccion) ? 'far fa-square' : 'fas fa-check-square'"></i>&nbsp;&nbsp;Todos los días</h6>
                    <!-- INPUT TIEMPO -->
                    <div id="inputs-rango-horas" class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-1 no-gutters">
                      <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2">
                        <h6>A partir de:</h6>
                        <input type="time" @change="evtCambioHoraTodos('INICIO')" :disabled="!todosLosDiasSeleccionados.seleccion" v-model="todosLosDiasSeleccionados.horaInicio" class="form-control texto-hora" />
                      </div>
                      <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2">
                        <h6>Hasta:</h6>
                        <input type="time" @change="evtCambioHoraTodos('FIN')" :disabled="!todosLosDiasSeleccionados.seleccion" v-model="todosLosDiasSeleccionados.horaFin" class="form-control texto-hora" />
                      </div>
                    </div>
                  </div>
                  <div v-for="(dia, index) in DIAS_SEMANA" :key="index" :class="(dia.seleccionado) ? 'color-dia-seleccionado dia-seleccion row col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0 pt-1 pl-3 no-gutters' : 'dia-seleccion row col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0 pt-1 pl-3 no-gutters'">
                    <h6 @click="evtSeleccionDia(dia.llave)"><i :class="(!dia.seleccionado) ? 'far fa-square' : 'fas fa-check-square'"></i>&nbsp;&nbsp;{{ dia.valor }}</h6>
                     <!-- INPUT TIEMPO -->
                    <div id="inputs-rango-horas" class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-1 no-gutters">
                      <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2">
                        <h6>A partir de:</h6>
                        <input type="time" v-model="dia.tiempo.horaInicio" :disabled="!dia.seleccionado" class="form-control texto-hora" />
                      </div>
                      <div class="form-group col-xs-6 col-sm-6 col-md-6 col-lg-6 pr-2">
                        <h6>Hasta</h6>
                        <input type="time" v-model="dia.tiempo.horaFin" :disabled="!dia.seleccionado" class="form-control texto-hora" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="form-group info col-12" id="ObservacionesResultado_div">
                <textarea v-model="obsAbogado" rows="3" class="form-control" ></textarea>
                <i>*Agregar notas a la cédula que faciliten su realización</i>
              </div>
            </div> -->
            <div class="text-right mt-3">
              <button class="btn btn-primary" id="historialAcuerdo_btn" @click="evtObtenerObservacion"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documentos-cedula-vdcp">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Documento de cédula</h5>
            <button id="btn-cerrar-visor-documentos-cedula-vdcp" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
          </div>
          <div class="modal-body">
            <div v-if="cedulaBD != null">
              <PDFDocument id="doc-cedula"
                :url="cedulaBD.ArchivoRuta" 
                :height="'600px'"
                :ocultarDescarga="true"
                :MarcaDeAgua="{ RutaImagenMarcaDeAgua: null, TextoMarcaDeAgua: 'DOCUMENTO RESERVADO' }"
                :key="'VDDCVCP' + contRenderDocumento"/>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>
<script>  
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import comun from "@/../static/js/comun"
  import api from '@/../static/js/api'
  import axios from 'axios'
  import router from '@/router/index'
  import VueMask from 'v-mask'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'

   export default {
    components: {        
      InformacionBasicaDeCedula: sistemas.SINOJ.CInformacionBasicaDeCedula,
      CCatalogoGenerico: sistemas.SINOJ.CCatalogoGenerico,
      PDFDocument    
    },
    data() {
      return {
        enumeraciones,
        cedulaBD: null,
        filtrosPreviosVistaPadre: null,
        numeroExpediente: null,
        estatus: 'Sin estatus',
        resultado: 'Sin resultado',
        observacionesResultado: 'Sin observaciones',
        contRenderDocumento: 0,
        obsAbogado: null,
        DIAS_SEMANA: [
          { llave: 1, valor: 'Lunes', seleccionado: false, tiempo: { horaInicio: null, horaFin:  null } },
          { llave: 2, valor: 'Martes', seleccionado: false, tiempo: { horaInicio: null, horaFin: null }  },
          { llave: 3, valor: 'Miercoles', seleccionado: false, tiempo: { horaInicio: null, horaFin:  null }  },
          { llave: 4, valor: 'Jueves', seleccionado: false, tiempo: { horaInicio: null, horaFin: null }  },
          { llave: 5, valor: 'Viernes', seleccionado: false, tiempo: { horaInicio: null, horaFin: null }  },
          { llave: 6, valor: 'Sabado', seleccionado: false, tiempo: { horaInicio: null, horaFin: null }  },
          { llave: 7, valor: 'Domingo', seleccionado: false, tiempo: { horaInicio: null, horaFin: null }  }
        ],
        rangoDeDias: false,
        rangoDeTiempo: false,
        catalogoDiasInicio: {
          ID: 'CDiasIVCP',
          valor: -1,
          TEXTO_SINGULAR: 'día.',
          TEXTO_PLURAL: 'días.',
          key: 'KCDiasFVCP',
          contRender: 0
        },
        catalogoDiasFin: {
          ID: 'CDiasFVCP',
          valor: -1,
          TEXTO_SINGULAR: 'día.',
          TEXTO_PLURAL: 'días.',
          key: 'KCDiasFVCP',
          contRender: 0
        },
        todosLosDiasSeleccionados: {
          seleccion: false,
          horaInicio: null,
          horaFin: null
        },
        horaInicio: null,
        horaFin: null
      }
    },
    methods: {
      evtLimpiarFormularioObservaciones: function() {
        this.DIAS_SEMANA.forEach(ds => {
          ds.seleccionado = false;
          ds.tiempo.horaInicio = null;
          ds.tiempo.horaFin = null;
        });
        this.todosLosDiasSeleccionados.seleccion = false;
        this.todosLosDiasSeleccionados.horaInicio = null;
        this.todosLosDiasSeleccionados.horaFin = null;
        this.catalogoDiasInicio.valor = -1;
        this.catalogoDiasFin.valor = -1;
        this.catalogoDiasInicio.contRender ++;
        this.catalogoDiasFin.contRender ++;
        this.horaInicio = null;
        this.horaFin = null;
      },
      evtObtenerObservacion: async function() {
        let observacion = null;
        if(this.rangoDeDias) {
           observacion = await Promise.resolve(this.obtenerObservacionConRangoDeDia());
           if(this.campoRequeridoEsValido(observacion))
            this.guardarObservacionBD(observacion)
           else
            comun.mensajeDeAlerta('No se puede guardar una observacion sin informacion.');
        }
        else {
          observacion = await Promise.resolve(this.obtenerObservacionSinRangoDeDias());
           if(this.campoRequeridoEsValido(observacion))
             this.guardarObservacionBD(observacion)
           else
            comun.mensajeDeAlerta('No se puede guardar una observacion sin informacion.'); 
        }
      },
      obtenerObservacionConRangoDeDia: async function() {
        let observacion = null;
        let aPartirDe = null;
        let hasta = null;
        let diaInicio = this.DIAS_SEMANA.find(ds => ds.llave == this.catalogoDiasInicio.valor);
        let diaFin = this.DIAS_SEMANA.find(ds => ds.llave == this.catalogoDiasFin.valor);
        observacion = 'La notificacion se puede realizar:\n';
        if(this.campoRequeridoEsValido(diaInicio) && this.campoRequeridoEsValido(diaFin)) {
          if(diaInicio.valor == diaFin.valor) 
            observacion += 'Todos los dias';
          else
            observacion += 'De ' + diaInicio.valor + ' a ' + diaFin.valor;
            
          let cualquierHora = (!this.campoRequeridoEsValido(this.horaInicio) && !this.campoRequeridoEsValido(this.horaFin));
            if(!cualquierHora) {
              aPartirDe = (this.campoRequeridoEsValido(this.horaInicio)) ? ' a partir de ' + this.horaInicio : '';
              hasta = (this.campoRequeridoEsValido(this.horaFin)) ? ' hasta ' + this.horaFin + ' horas del dia.' : '';
              observacion += aPartirDe + hasta;
            }
            else {
              observacion += ' a caulquier hora del dia.';
            }
        }
        else {
          observacion += 'Todos los dias';
          let cualquierHora = (!this.campoRequeridoEsValido(this.horaInicio) && !this.campoRequeridoEsValido(this.horaFin));
            if(!cualquierHora) {
              aPartirDe = (this.campoRequeridoEsValido(this.horaInicio)) ? ' a partir de ' + this.horaInicio : '';
              hasta = (this.campoRequeridoEsValido(this.horaFin)) ? ' hasta ' + this.horaFin + ' horas del dia.' : '';
              observacion += aPartirDe + hasta;
            }
            else {
              observacion += ' a caulquier hora del dia.';
            }
        }
        return observacion;
      },
      obtenerObservacionSinRangoDeDias: async function() {
        let observacion = null;
        let aPartirDe = null;
        let hasta = null;
        const DIAS_SELECCIONADOS = this.DIAS_SEMANA.filter(ds => ds.seleccionado);
        if(DIAS_SELECCIONADOS.length > 0) {
          observacion = 'La notificacion se puede realizar:\n';
          if(this.todosLosDiasSeleccionados.seleccion) {
            observacion += 'Todos los dias';
            let cualquierHora = (!this.campoRequeridoEsValido(this.todosLosDiasSeleccionados.horaInicio) && !this.campoRequeridoEsValido(this.todosLosDiasSeleccionados.horaFin));
            if(!cualquierHora) {
              aPartirDe = (this.campoRequeridoEsValido(this.todosLosDiasSeleccionados.horaInicio)) ? ' a partir de ' + this.todosLosDiasSeleccionados.horaInicio : '';
              hasta = (this.campoRequeridoEsValido(this.todosLosDiasSeleccionados.horaFin)) ? ' hasta ' + this.todosLosDiasSeleccionados.horaFin + ' horas del dia.' : '';
              observacion += aPartirDe + hasta;
            }
            else
              observacion += ' a cualquier hora.';
            return observacion;
          }
          
          DIAS_SELECCIONADOS.forEach(d => {
            observacion += 'Día ' + d.valor + " : [";
            let cualquierHora = (!this.campoRequeridoEsValido(d.tiempo.horaInicio) && !this.campoRequeridoEsValido(d.tiempo.horaFin));
            if(!cualquierHora) {
              aPartirDe = (this.campoRequeridoEsValido(d.tiempo.horaInicio)) ? ' a partir de ' + d.tiempo.horaInicio : '';
              hasta = (this.campoRequeridoEsValido(d.tiempo.horaFin)) ? ' hasta ' + d.tiempo.horaFin + ' horas del dia.' : '';
              observacion += aPartirDe + hasta + ' ]\n';
            }
            else
              observacion += 'a cualquier hora del día]';
          });
        }
        return observacion;
      },
      evtCambioHoraTodos: function(tipoDeHora) {
        /* horaInicio: moment().format('HH:mm') */
        switch(tipoDeHora) {
          case 'INICIO':
            if(this.todosLosDiasSeleccionados.seleccion)
              this.DIAS_SEMANA.forEach(d => {
                d.tiempo.horaInicio = this.todosLosDiasSeleccionados.horaInicio;
              });
            break;
          case 'FIN':
            if(this.todosLosDiasSeleccionados.seleccion)
              this.DIAS_SEMANA.forEach(d => {
                d.tiempo.horaFin = this.todosLosDiasSeleccionados.horaFin;
              });
            break;
          default:
            break;
        }
      },
      evtTodosLosDiasSeleccionados: function() {
        const ESTADO_SLECCION = !this.todosLosDiasSeleccionados.seleccion;
        this.todosLosDiasSeleccionados.seleccion = ESTADO_SLECCION;
        this.DIAS_SEMANA.forEach(d => {
          d.seleccionado = this.todosLosDiasSeleccionados.seleccion;
        });
        if(this.todosLosDiasSeleccionados.seleccion) {
          this.DIAS_SEMANA.forEach(d => {
            d.tiempo.horaInicio = this.todosLosDiasSeleccionados.horaInicio;
            d.tiempo.horaFin = this.todosLosDiasSeleccionados.horaFin;
          });
        }
      },
      evtSeleccionDia: function(diaSeleccionado) {
        const DIA_SELECCIONADO_OBJ = this.DIAS_SEMANA.find(d => d.llave == diaSeleccionado);
        if(this.campoRequeridoEsValido(DIA_SELECCIONADO_OBJ)) {
          const ESTADO_SLECCION = !DIA_SELECCIONADO_OBJ.seleccionado;
          DIA_SELECCIONADO_OBJ.seleccionado = ESTADO_SLECCION;
          if(this.DIAS_SEMANA.filter(ds => ds.seleccionado).length == this.DIAS_SEMANA.length)
            this.todosLosDiasSeleccionados.seleccion = true;
          else
            this.todosLosDiasSeleccionados.seleccion = false;
        }
      },
      evtCambioDeDia: function(evento, tipoDeDia) {
        const ID_SELECCION = parseInt(evento.target.value);
        switch(tipoDeDia) {
          case 'INICIO':
            this.catalogoDiasInicio.valor = ID_SELECCION;
            break;
          case 'FIN':
            this.catalogoDiasFin.valor = ID_SELECCION;
            break;
          default:
            break;
        }
      },
      obtenerObservacionesAbogado: function() {
        let observaciones = [];
        let observacionObj = {
          ObservacionAbogadoId: -1,
          Observaciones: this.obsAbogado,
          Usuario: null,
          Cedula: null
        };
        observaciones.push(observacionObj);
        return observaciones;
      },
      guardarObservacionBD: function(observacion) { 
        const SERVIDOR = api.conexion;
        const METODO_API_GUARDAR = api.SINOJ.sistema.consultas.consultaPublica.GuardarObservacionesDeAbogado;
        let urlApi = SERVIDOR + METODO_API_GUARDAR;
        let peticionArchivos = false;
        let peticionAPI = {
            Cedula: {
              CedulaId: this.cedulaBD.CedulaId,
              ObservacionesDeAbogados: [
                {
                  ObservacionAbogadoId: -1,
                  Observaciones: observacion,
                  Usuario: null,
                  Cedula: null
                }
              ]
            },
            esPrueba: false
        }
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        let mensajeError = respuesta.data.Error.Mensaje;
                        console.log(mensajeError);
                        comun.mensajeDeAlerta(mensajeError, null, null);
                    } 
                    else {
                        //console.log('data::',respuesta.data.Cedula)
                        this.cedulaBD = (respuesta.data.Cedula != null) ? respuesta.data.Cedula : null;
                        if(this.campoRequeridoEsValido(this.cedulaBD.Expediente)) {
                          this.numeroExpediente = this.cedulaBD.Expediente.NumeroDeDocumento;
                          this.estatus = this.cedulaBD.Estatus.Nombre;
                        }
                        this.asignarValoresDeResultado(this.cedulaBD.Resultado);
                        this.contRenderDocumento ++;
                        comun.SeEstaCargandoInformacion(false);
                        this.obsAbogado = null;
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                        this.evtLimpiarFormularioObservaciones();
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    this.cargandoCedulas = false;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(excepcion);
                    comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                }
        ); 
      },
      evtVisualizarDocumento: function() {
        $('#visor-documentos-cedula-vdcp').modal('show');
      },
      evtGuardarObservaciones: function() {
        if(this.campoRequeridoEsValido(this.obsAbogado)) {
          this.guardarObservacionBD();
        }
        else {
          comun.mensajeDeAlerta('Se detectaron campos incorrectos,<br>No se permiten valores nulos en una observacion');
        }
      },  
      regresarAVistaPrincipal: function() {
        let tieneFiltroPrevios = Object.values(this.filtrosPreviosVistaPadre).some(f => this.campoRequeridoEsValido(f));
        this.filtrosPreviosVistaPadre.cargarConFiltros = tieneFiltroPrevios;
        router.push({ name: "ConsultaPublica", params: { filtrosParaCargar: this.filtrosPreviosVistaPadre } });
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      asignarValoresDeResultado: function(resultado) {
        if(this.campoRequeridoEsValido(resultado)) {
          const { TipoResultado, ObservacionesResultado } = resultado;
          this.resultado = (this.campoRequeridoEsValido(TipoResultado)) ? TipoResultado.Nombre : 'Sin resultado';
          this.observacionesResultado = (this.campoRequeridoEsValido(ObservacionesResultado)) ? ObservacionesResultado : 'Sin observaciones';
        }
      }
    },
    computed: {
      textoRangoDeFechas() {
        return (this.catalogoDiasInicio.valor != this.catalogoDiasFin.valor) ? 
          `${(this.campoRequeridoEsValido(this.catalogoDiasInicio.valor)) ? this.DIAS_SEMANA.find(d => d.llave == this.catalogoDiasInicio.valor).valor : ''} a ${(this.campoRequeridoEsValido(this.catalogoDiasFin.valor)) ? this.DIAS_SEMANA.find(d => d.llave == this.catalogoDiasFin.valor).valor : ''}` :
          `${(this.campoRequeridoEsValido(this.catalogoDiasInicio.valor)) ? this.DIAS_SEMANA.find(d => d.llave == this.catalogoDiasInicio.valor).valor : ''}`;
      }
    },
    mounted() {
     
    },
    created() {
      const PARAMETROS_VISTA = router.history.current.params;
        if(!this.campoRequeridoEsValido(PARAMETROS_VISTA.cedula) || !this.campoRequeridoEsValido(PARAMETROS_VISTA.filtrosPrevios)) {
            router.push({ name: "ConsultaPublica"});
        }
        else {
            this.cedulaBD = PARAMETROS_VISTA.cedula;
            this.filtrosPreviosVistaPadre = PARAMETROS_VISTA.filtrosPrevios;
            if(this.campoRequeridoEsValido(this.cedulaBD.Expediente)) {
              this.numeroExpediente = this.cedulaBD.Expediente.NumeroDeDocumento;
              this.estatus = this.cedulaBD.Estatus.Nombre;
            }
            this.asignarValoresDeResultado(this.cedulaBD.Resultado);
        }
    }
  }
</script>
<style scoped>
textarea {
  padding: 0.6em !important;
}

#visor-documentos-cedula-vdcp .modal-lg {
    max-width: 70% !important;
}

#visor-documentos-cedula-vdcp .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#marca-agua-documento {
  position: absolute;
  width: 40%;
  height: 30%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  top: 26%;
}

#encabezado-contenedor-contenido {
  background-color: rgb(44, 43, 43);
  padding: 10px;
}

#encabezado-contenedor-contenido .btn {
  background-color: black;
  padding-left: 15px;
  padding-right: 15px;
}

.contenedor-informacion {
  background-color: #323335;
  padding: 25px;
}

.contenedor-color-negro {
    padding: 1.5em;
    background-color: #2c2d31;
    box-shadow: 0px 6px 20px 8px #161616;
}

.contenedor-documento-cedula {
    padding: 5px 9px 5px 9px;
    border-radius: 4px;
    background-color: #817c7c;
}

#contenedor-acciones-documento .btn-sm {
    cursor: pointer;
    padding: 6px 10px 6px 10px;
    background-color: #555558;
}

#contenedor-acciones-documento .btn-sm:hover {
    background-color: black;
}

.switch-rango .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.switch-rango .btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.switch-rango .btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

.texto-ajustable-switch {
    font-size: 1vw;
}

.listado-seleccion {
    border: 2px solid #4d4a4a;
    padding: 1.3em 0.9em 1.3em 0.9em;
}

.dia-seleccion h6 {
  cursor: pointer;
}

.dia-seleccion {
  border: 1px solid white;
}

.color-dia-seleccionado {
  background-color: #1e1f22;
}

.texto-hora {
  font-size: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Consultas/ConsultaPublica/DetallesCedula.vue